export const ARTICLE_TAG_COLORS: { [key: string]: string } = {
  breeds: '#9e1030',
  breeders: '#00539c',
  shelters: '#d69c2f',
  legal: '#be9ec9',
  advice: '#006e6d',
  behaviour: '#e94b3c',
  educationandtraining: '#ec9787',
  activities: '#00a591',
  preventativecare: '#6b5b95',
  diseases: '#bc70a4',
  grooming: '#2e4a62',
  nutrition: '#92b558',
  tipawhelpsbreeders: '#dc4c46',
};

// &.tag0 {
//   background-color: #fe840e;
// }

// &.tag13 {
//   background-color: #dc4c46;
// }

// &.tag14 {
//   background-color: #672e3b;
// }

// &.tag15 {
//   background-color: #4f84c4;
// }

// &.tag16 {
//   background-color: #c62168;
// }

// &.tag17 {
//   background-color: #39cccc;
// }

// &.tag18 {
//   background-color: #85144b;
// }

// &.tag19 {
//   background-color: #ff6f61;
// }
